export default __webpack_public_path__ + "static/media/black-heart.a6e1ea8d.svg";